<template>
  <el-popover placement="bottom-end" width="360" trigger="click" @show="load">
    <div class="notify-panel">
      <div class="notify-head">
        <span>系统通知</span>
        <el-button type="text" size="mini" @click="markAll">全部已读</el-button>
      </div>
      <div v-loading="loading" class="notify-list">
        <div v-for="n in list" :key="n.guid" class="notify-item" :class="{ unread: !n.read }" @click="markOne(n)">
          <div class="notify-title">{{ n.title }}</div>
          <div class="notify-msg">{{ n.message }}</div>
          <div class="notify-time">{{ formatTime(n.createdAt) }}</div>
        </div>
        <div v-if="!loading && !list.length" class="notify-empty">暂无通知</div>
      </div>
    </div>
    <el-badge :value="unread" :hidden="!unread" slot="reference" class="notify-badge">
      <el-button type="text" icon="el-icon-bell" />
    </el-badge>
  </el-popover>
</template>

<script>
import { listNotifications, markNotificationsRead } from '@/api/admin'

export default {
  data() {
    return { loading: false, list: [], unread: 0 }
  },
  mounted() {
    this.load()
    this.timer = setInterval(() => this.load(), 60000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listNotifications({ limit: 20 })
        this.list = res.list || []
        this.unread = res.unread || 0
      } finally {
        this.loading = false
      }
    },
    async markOne(n) {
      if (!n.read) {
        await markNotificationsRead({ guid: n.guid })
        n.read = true
        this.unread = Math.max(0, this.unread - 1)
      }
    },
    async markAll() {
      await markNotificationsRead({ all: true })
      this.list.forEach(n => { n.read = true })
      this.unread = 0
    },
    formatTime(iso) {
      if (!iso) return ''
      return iso.replace('T', ' ').slice(0, 16)
    }
  }
}
</script>

<style scoped>
.notify-panel { max-height: 360px; display: flex; flex-direction: column; }
.notify-head {
  display: flex; justify-content: space-between; align-items: center;
  padding-bottom: 8px; border-bottom: 1px solid var(--mhx-neutral-100);
  font-weight: 600; font-size: 14px;
}
.notify-list { overflow-y: auto; max-height: 300px; margin-top: 8px; }
.notify-item {
  padding: 10px 4px; border-bottom: 1px solid var(--mhx-neutral-100); cursor: pointer;
}
.notify-item:hover { background: var(--mhx-neutral-50); }
.notify-item.unread { border-left: 3px solid var(--mhx-primary); padding-left: 8px; }
.notify-title { font-size: 13px; font-weight: 500; }
.notify-msg { font-size: 12px; color: var(--mhx-neutral-600); margin-top: 4px; line-height: 1.4; }
.notify-time { font-size: 11px; color: var(--mhx-neutral-400); margin-top: 4px; }
.notify-empty { text-align: center; padding: 24px; color: var(--mhx-neutral-400); font-size: 13px; }
.notify-badge { margin-right: 4px; }
</style>
